import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate ,Link } from "react-router-dom";
import { axiosOpen } from "../../api/axios";
import Variables from "../../constants/Variables";
import './PortFolio.css';
const AddPortfolioForm = (props) => {
  const [data, setData] = useState(props.stacks);
  const [portfolios, setPortfolios] = useState("");
  const [project, setProject] = useState("");
  const [techstacks, setTechstacks] = useState("");
  const [newtechstacks, setNewTechstacks] = useState("");
  const [list, setList] = useState("");
  const techStacks = Variables.techStacks;
  // const stacks = TechStacks.techStacks;
  // const { user } = useContext(AuthContext);
  const companyID = localStorage.getItem("compId");
  const [techStackList, setTechStackList] = useState([]);
  const { register } = useForm();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axiosOpen.get(`api/singletechstack/getSingleTechStack/${companyID}`);
        setTechStackList(data?.techStacks || []);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  let projects = project;
  let portfolio = portfolios;
  let techstack = techstacks;
  const navigate = useNavigate();

  const handleSubmit = (event) => async () => {
    // event.preventDefault();

    console.log(projects, portfolio, techstack);
    const payload = JSON.stringify({
      userid: localStorage.getItem("userID"),
      techstack: techstack,
      portfolio: portfolio,
      project: projects,
    });

    const response = await axiosOpen.post("api/techstack/addPortfolio", payload);
    //  axiosOpen.get("api/techstack/getAllTechstacks/"+localStorage.getItem('userID'))
    //  .then(response => {
    //    let result = response;
    //    var index
    //    result.data.map((portfolio)=>{
    //        index = props.stacks.indexOf(portfolio.tech_stack);
    //          if (index > -1) { // only splice array when item is found
    //           props.stacks.splice(index, 1); // 2nd parameter means remove one item only
    //          }
    //      })
    //      setData(props.stacks);
    //    })
    //  .catch(error => {
    //    toast.error(error.message);
    //    console.log(error);
    //  });
    //  toast.success('Portfolio Added Successfully');
    navigate("/portfolio");
  };

  return (
    <>
      {/* <div> <Toaster/></div> */}
      {props.loader ? (
        <div className="d-flex justify-content-center align-items-center h-100">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="row" style={{ padding: "40px" }}>
          <div className="col-2">
            {/* <Sidebar /> */}
          </div>
          <div className="col-9">
            <div className='article-title'>
              <Row>
                <div className="mb-3">
                  <h3 className="title">Add Portfolio</h3>
                </div>
                <Col md="9">
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col>
                        {
                          <>
                          
                            <Form.Group className="mb-4" >
                            <div className="d-flex  align-items-centre me-5 height">
                              <div className="w-50 ">
                              {/* <Form.Group className="mb-4"> */}
                              <Form.Label className="portfolio-header bold-label">Technology used*</Form.Label>
                              <Form.Select aria-label="Default select example" onChange={(e) => setTechstacks(e.target.value)} value={techstack}>
                                <option>Select The Tech Stack</option>
                                {
                                  techStackList.length > 0 && techStackList.map((item, index) => (<option key={index} value={item}>
                                    {item}
                                  </option>))
                                }
                                
                              </Form.Select>
                             
                              </div>
                              <h3 className="title my-custom-padding">OR</h3>
                              <Link  className="pt-5 me-5" to="/techstack">Add TechStack</Link>
                              </div>
                              {/* </Form.Group> */}
                              {/* <Form.Group > */}
                              <Form.Label className="portfolio-header pt-3 bold-label">Portfolio URL</Form.Label>


                              <Form.Control

                                type="text"
                                placeholder="Enter Portfolio URL"
                                {...register("portfolio", { required: false })}
                                value={portfolios}
                                onChange={(e) => setPortfolios(e.target.value)}
                              />
                              <br />
                              {/* </Form.Group>
                                      <Form.Group > */}
                              <Form.Label className="project-header bold-label">Portfolio Description </Form.Label>

                              <Form.Control

                                as="textarea"
                                placeholder="Projects"
                                rows={6}
                                {...register("projects", { required: false })}
                                value={project}
                                onChange={(e) => setProject(e.target.value)}
                              />


                              {/* </Form.Group> */}
                              <br />
                              <Button className='update-btn' onClick={handleSubmit()}>Save</Button>
                            </Form.Group>
                          </>

                        }
                      </Col>
                    </Row>
                    {/* <div className='text-end' onClick={handleSubmit}> */}



                  </Form>

                </Col>
              </Row>
            </div>
          </div>
        </div>
      )}
    </>
  )
};

export default AddPortfolioForm;
